import { Modal, Button } from "@thetreep/ui";
import { useTranslation } from "react-i18next";
interface WarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
}

export function WarningModal({
  isOpen,
  onClose,
  onConfirm,
}: WarningModalProps) {
  const { t } = useTranslation();

  return (
    <Modal size="default" isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-4">
        <span className="font-jakarta font-bold text-text-strong text-md">
          {t("booking.warning.title")}
        </span>
        <div>
          <p className="font-roboto text-text-strong">
            {t("booking.warning.text")}
          </p>
        </div>
        <div className="flex gap-2 justify-end">
          <Button onClick={onClose} kind="outline" size="compact">
            {t("booking.warning.cancel")}
          </Button>
          <Button onClick={onConfirm} size="compact">
            {t("booking.warning.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
